import {
  ChooseCountry,
  HomePage,
  Payment,
  ProfileSearch,
  ProfileResult,
  ViewVisa,
  PolicyPage,
  OurServicesPage,
  VisaRequirements,
  VisaRequirementDetails,
  NewsPage,
  NewsDetail,
  FAQPage,
  InstructionPage,
  ContactPage,
  EmergencyInquiryPage,
  AboutUsPage,
  TransportationPage
} from "../../pages";
import { path } from "../common/constant";

const routes = [
  {
    path: `${path.HOME}`,
    component: <HomePage />,
    main: () => <HomePage />
  },
  {
    path: `${path.CHOOSE_COUNTRY}`,
    component: <ChooseCountry />,
    main: () => <ChooseCountry />
  },
  {
    path: `${path.VISA_APPLICATION}`,
    component: <Payment />,
    main: () => <Payment />
  },
  {
    path: `${path.PROFILE_SEARCH}`,
    component: <ProfileSearch />,
    main: () => <ProfileSearch />
  },
  {
    path: `${path.PROFILE_RESULT}`,
    component: <ProfileResult />,
    main: () => <ProfileResult />
  },
  {
    path: `${path.VIEW_VISA}`,
    component: <ViewVisa />,
    main: () => <ViewVisa />
  },
  {
    path: `${path.POLICY}`,
    component: <PolicyPage />,
    main: () => <PolicyPage />
  },
  {
    path: `${path.OUR_SERVICES}`,
    component: <OurServicesPage />,
    main: () => <OurServicesPage />
  },
  {
    path: `${path.REQUIREMENTS}`,
    component: <VisaRequirements />,
    main: () => <VisaRequirements />
  },
  {
    path: `${path.VISA_REQUIREMENT_DETAILS}`,
    component: <VisaRequirementDetails />,
    main: () => <VisaRequirementDetails />
  },
  {
    path: `${path.ABOUT_US}`,
    component: <AboutUsPage />,
    main: () => <AboutUsPage />
  },
  {
    path: `${path.NEWS}`,
    component: <NewsPage />,
    main: () => <NewsPage />
  },
  {
    path: `${path.NEWS_DETAIL}`,
    component: <NewsDetail />,
    main: () => <NewsDetail />
  },
  {
    path: `${path.FAQ}`,
    component: <FAQPage />,
    main: () => <FAQPage />
  },
  {
    path: `${path.INSTRUCTION}`,
    component: <InstructionPage />,
    main: () => <InstructionPage />
  },
  {
    path: `${path.CONTACT}`,
    component: <ContactPage />,
    main: () => <ContactPage />
  },
  {
    path: `${path.EMERGENCY_INQUIRY}`,
    component: <EmergencyInquiryPage />,
    main: () => <EmergencyInquiryPage />
  },
  {
    path: `${path.TRANSPORTATION}`,
    component: <TransportationPage />,
    main: () => <TransportationPage />
  }
];

export default routes;
